import { useGetApplication } from 'app/hooks';
import { type HomeTemplate } from 'app/modules/Parameters/Home/types';
import { type TemplateWeb } from 'app/modules/Taxpayer/TaxpayerRequest/types';
import { type ResponseValues } from 'axios-hooks';

interface ResponseValuesExtend extends ResponseValues<HomeTemplate, any, any> {
  execute: any;
}

interface ResponsePaymentNotes extends ResponseValues<TemplateWeb, any, any> {
  execute: any;
}

export const useGetHomeTemplate: (
  id: string,
  type: string,
  onLoadMode?: boolean
) => ResponseValuesExtend = (id: string, type: string, onloadMode?: boolean) => {
  const [{ data, loading, error, response }, execute] = useGetApplication<HomeTemplate>(
    {
      url: '/template/home',
      params: {
        language: id,
        type: type
      }
    },
    onloadMode === undefined ? true : onloadMode
  );

  return { loading, data, error, response, execute };
};

export const useGetPaymentReference: (id: string, onLoadMode?: boolean) => ResponsePaymentNotes = (
  id: string,
  onloadMode?: boolean
) => {
  const [{ data, loading, error, response }, execute] = useGetApplication<TemplateWeb>(
    {
      url: '/payments/declaration/notes',
      params: {
        language: id
      }
    },
    onloadMode === undefined ? true : onloadMode
  );

  return { loading, data, error, response, execute };
};
